import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from '../../../../Constants';

const TimeTicketEntryList = ({user}) => {
    const [timeTicketCards, setTimeTicketCards] = useState([]);
    const navigate = useNavigate();

    const handleEdit = async (id) => {
        const x = encodeURIComponent(JSON.stringify(timeTicketCards));
        navigate(`/call-center/edit-timeticketentry/${id}/${x}`);
    };


    useEffect(() => {
        const fetchTimeTicketCards= async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/api/admin/timeTicketEntries`,{
                    headers: {
                      'Content-Type': 'application/json',
                  },
                    credentials: 'include',
                  });
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                setTimeTicketCards(data);
            } catch (error) {
                console.error('Fetch error: ', error);
            }
        };

        fetchTimeTicketCards();
        const intervalId = setInterval(fetchTimeTicketCards, 5000);

        return () => clearInterval(intervalId);
    }, []);

    const handleDelete = async (id) => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/admin/deleteTimeTicketEntry/${id}`, {
                method: 'DELETE',
                credentials: 'include',
            });

            if (response.ok) {
                setTimeTicketCards(timeTicketCards.filter(timeTicketEntry => timeTicketEntry.timeTicketId !== id));
                alert('Time TIcket Entry deleted successfully');
            } else if (response.status === 401) {
                alert('Unauthorized. Please log in.');
                navigate('/login');
            } else {
                throw new Error('Failed to delete time card entry');
            }
        } catch (error) {
            alert('An error occurred while deleting trouble call',error.message);
        }
    };

    return (
        <div className="mx-auto ml-4 h-screen w-full">
            <div className="flex justify-between items-center mb-4">
                <h2 className="text-2xl font-bold">Time Ticket Entry List</h2>
            </div>
                <table className="min-w-full bg-white rounded-lg shadow-lg overflow-hidden border-2 border-gray-200">
                    <thead className="bg-gray-200">
                        <tr>
                            <th className="px-4 py-2 text-left font-semibold text-gray-600">Time Ticket Id</th>
                            <th className="px-4 py-2 text-left font-semibold text-gray-600">Employee Id</th>
                            <th className="px-4 py-2 text-left font-semibold text-gray-600">Building Site</th>
                            <th className="px-4 py-2 text-left font-semibold text-gray-600">Ticket Number</th>
                            <th className="px-4 py-2 text-left font-semibold text-gray-600">Device Information</th>
                            <th className="px-4 py-2 text-left font-semibold text-gray-600">Description</th>
                            <th className="px-4 py-2 text-left font-semibold text-gray-600">Expense</th>
                            <th className="px-4 py-2 text-left font-semibold text-gray-600">Hours Type</th>
                            <th className="px-4 py-2 text-left font-semibold text-gray-600">Hours</th>
                            <th className="px-4 py-2 text-left font-semibold text-gray-600">Reg</th>
                            <th className="px-4 py-2 text-left font-semibold text-gray-600">Problem Class</th>
                            <th className="px-4 py-2 text-left font-semibold text-gray-600">Sub Class</th>
                            <th className="px-4 py-2 text-left font-semibold text-gray-600">Start Time</th>
                            <th className="px-4 py-2 text-left font-semibold text-gray-600">End Time</th>
                            <th className="px-4 py-2 text-left font-semibold text-gray-600">Status</th>
                            <th className="px-4 py-2 text-left font-semibold text-gray-600">Type</th>
                            <th className="px-4 py-2 text-left font-semibold text-gray-600">Actions</th>
                            
                        
                          
                        </tr>
                    </thead>
                    <tbody className="text-gray-700">
                        {timeTicketCards.map((timeTicketEntry) => (
                            <tr key={timeTicketEntry.troubleCallId} className="border-t">
                                <td className="px-4 py-2">{timeTicketEntry.timeTicketId}</td>
                                <td className="px-4 py-2">{timeTicketEntry.employeeId}</td>
                                <td className="px-4 py-2">{timeTicketEntry.buildingSite}</td>
                                <td className="px-4 py-2">{timeTicketEntry.ticketNumber}</td>
                                <td className="px-4 py-2">{timeTicketEntry.deviceInformation}</td>
                                <td className="px-4 py-2">{timeTicketEntry.description}</td>
                                <td className="px-4 py-2">{timeTicketEntry.expense}</td>
                                <td className="px-4 py-2">{timeTicketEntry.hoursType}</td>
                                <td className="px-4 py-2">{timeTicketEntry.hours}</td>
                                <td className="px-4 py-2">{timeTicketEntry.reg}</td>
                                <td className="px-4 py-2">{timeTicketEntry.problemClass}</td>
                                <td className="px-4 py-2">{timeTicketEntry.subClass}</td>
                                <td className="px-4 py-2">{timeTicketEntry.startTime}</td>
                                <td className="px-4 py-2">{timeTicketEntry.endTime}</td>
                                <td className="px-4 py-2">{timeTicketEntry.status}</td>
                                <td className="px-4 py-2">{timeTicketEntry.type}</td>
                                <td className="px-4 py-2">
                                    <button className="text-blue-600 mr-2" onClick={() => handleEdit(timeTicketEntry.timeTicketId)}>Edit</button>
                                    <button className="text-red-600" onClick={() => handleDelete(timeTicketEntry.timeTicketId)}>Delete</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
        </div>
    );
};

export default TimeTicketEntryList;
